module.exports = __webpack_public_path__ + "img/ico_zy@3x.a666d7cf.png";